import { render, staticRenderFns } from "./DetailsPayments.vue?vue&type=template&id=38f80ddc&scoped=true"
import script from "./DetailsPayments.vue?vue&type=script&lang=js"
export * from "./DetailsPayments.vue?vue&type=script&lang=js"
import style0 from "./DetailsPayments.vue?vue&type=style&index=0&id=38f80ddc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f80ddc",
  null
  
)

export default component.exports